import { render, staticRenderFns } from "./BudgetReport.vue?vue&type=template&id=a116953c&scoped=true&"
import script from "./BudgetReport.vue?vue&type=script&lang=js&"
export * from "./BudgetReport.vue?vue&type=script&lang=js&"
import style0 from "./BudgetReport.vue?vue&type=style&index=0&id=a116953c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a116953c",
  null
  
)

export default component.exports